import React from 'react';
import Connect4Game from './components/Connect4Game';
import './App.css';

function App() {
  return (
    <div className="App">
      <Connect4Game />
    </div>
  );
}

export default App;
